export const listReportRuns = `
   query listReportRuns($limit: Int, $nextToken: String) {
       listReportRuns(limit: $limit, nextToken: $nextToken) {
           items {
              id
              created
              error
              livemode
              parameters {
                  columns
                  connectedAccount
                  currency
                  intervalEnd
                  intervalStart
                  payout
                  reportingCategory
                  timezone
              }
              reportType
              result
              status
              succeededAt
           }
           nextToken
       }
   }
`;

export const getReportRun = `
   query getReportRun($id:ID!) {
       getReportRun(id:$id) {
         id
         created
         error
         livemode
         parameters {
             columns
             connectedAccount
             currency
             intervalEnd
             intervalStart
             payout
             reportingCategory
             timezone
         }
         reportType
         result
         status
         succeededAt
       }
}`;
